export default __webpack_public_path__ + "static/media/01019050e515b40cec7ead6f9c412f8e.e680303e.svg";